import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../src/assets/logo.png";
import image1 from "../../src/assets/car-items/img1.png";
import image2 from "../../src/assets/car-items/img2.png";
import image3 from "../../src/assets/car-items/img3.png";
import image4 from "../../src/assets/car-items/img4.png";
import "./Landing_Modal.css";
import translations from "./translation.js";

const Landing = () => {
    const imageRef = useRef(null);
    const imgRefMobile = useRef(null);
    const navigate = useNavigate();
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const storedLanguage = localStorage.getItem('selectedLanguage');
    const currentLanguage = storedLanguage || "en";

    console.log(storedLanguage);
    console.log(currentLanguage);
    console.log(console.log(translations["en"].welcomeMessage));

    useEffect(() => {
        if (sessionStorage.getItem("token")) {
          navigate("/feed");
        }
      }, []);

    const handleLanguageChange = (e) => {
        setSelectedLanguage(e.target.value);
        localStorage.setItem('selectedLanguage', e.target.value);
        switch (e.target.value) {
        case "en":
            window.location.reload();
            break;
        case "ch":
            window.location.reload();
            break;
        default:
            break;
        }
    };
    useEffect(() => {
        const rotateImages = () => {
            const images = [{"img":image1, "alt":"Join game communities"}, {"img":image2, "alt":"Make new friends"}, {"img":image3, "alt":"Find new games"}, {"img":image4, "alt":"Share ranks and level up"}];
            let currentIndex = 0;

            setInterval(() => {
                currentIndex = (currentIndex + 1) % images.length;
                imageRef.current.src = images[currentIndex].img;
                imageRef.current.alt = images[currentIndex].alt;
            }, 4000);
        };
        const rotateImagesMobile = () => {
            // const images = [image1, image2, image3, image4];
            const images = [{"img":image1, "alt":"Join game communities"}, {"img":image2, "alt":"Make new friends"}, {"img":image3, "alt":"Find new games"}, {"img":image4, "alt":"Share ranks and level up"}];
            let currentIndex = 0;

            setInterval(() => {
                currentIndex = (currentIndex + 1) % images.length;
                imgRefMobile.current.src = images[currentIndex].img;
                imgRefMobile.current.alt = images[currentIndex].alt;
            }, 4000);
        };
        document.title = 'TeamUp';
        rotateImages();
        rotateImagesMobile();

        // if (sessionStorage.getItem("token")) {
        //     navigate("/feed");
        //   }

        if (imageRef.current && !imageRef.current.src) {
            imageRef.current.src = image1;
        }

        if (imgRefMobile.current && !imgRefMobile.current.src) {
            imgRefMobile.current.src = image1;
        }
    }, []);

    return (
        <div className= "background" >
            <div className="landing-content">
                <div className="landing-desktop">
                <div className="img-container"><img ref={imageRef} className="rot-img" /></div>
                {/* <hr style={{border: "1px solid #F4C41A", height: "80%"}} className="landing-desktop"/> */}
                </div>
                <div className="right">
                    <img src={logo} alt="logo" className="logo" />
                    <div className="img-container landing-mobile"><img ref={imgRefMobile} className="rot-img" /></div>
                    <p className="tagline">{translations[currentLanguage].welcomeMessage}</p>
                    <div className="landing-buttons">
                        <Link to='/login'>
                            <button className="login">{translations[currentLanguage].login}</button>
                        </Link>
                        <Link to='/register'>
                            <button className="register">{translations[currentLanguage].register}</button>
                        </Link>
                        <select 
                        className="Landing_LanguageMenu_dropdown"
                        value={selectedLanguage}
                        onChange={handleLanguageChange}
                        > 
                        <option value="" disabled>
                            {translations[currentLanguage].language}</option>
                        <option value="en">{translations[currentLanguage].english}</option>
                        <option value="ch">{translations[currentLanguage].chinese}</option>
                        {/* Add more language options as needed */}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );

};
export default Landing;